import { render, staticRenderFns } from "./medicion-severidad.vue?vue&type=template&id=6eb76dce&scoped=true&"
import script from "./medicion-severidad.vue?vue&type=script&lang=js&"
export * from "./medicion-severidad.vue?vue&type=script&lang=js&"
import style0 from "./medicion-severidad.vue?vue&type=style&index=0&id=6eb76dce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb76dce",
  null
  
)

export default component.exports